<template>
  <vs-sidebar
    click-not-close
    position-right
    v-model="dialogShow"
    class="items-no-padding password-setting sidebar-dialog"
  >
    <div class="sidebar-content h-full">
      <div class="customizer-header flex items-center justify-between px-6 sliderbar-header">
        <div>
          {{title}}
        </div>
        <feather-icon icon="XIcon" @click.stop="closeHandle" class="cursor-pointer"></feather-icon>
      </div>
      <VuePerfectScrollbar
        class="scroll-area--customizer pt-4 pb-6" :settings="settings" :key="$vs.rtl"
      >
        <div class="content px-6">
          <div class="tab-inner">
            <div class="tab-item"
              v-for="(item,index) in computedList"
                 :key="index"
                 :class="{on: item.type == type}"
                 :style="getBgcOpacity(item)"
                 @click="typeHandle(item)"
            >{{item.label}}</div>
          </div>
          <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-position="top"
          >
            <el-form-item
              :label="$t('MT4_account')"
              prop="login"
            >
              <el-select
                :placeholder="$t('please_choose')"
                style="width: 100%"
                v-model="form.login"
                @change="loginChangeHandle"
              >
                <el-option
                  v-for="(item,index) in accountList"
                  :key="index"
                  :label="item.login"
                  :value="item.login"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="$t('User.newPass')"
              prop="password"
            >
              <el-input
                show-password
                v-model="form.password"
                :placeholder="$t('_8_20_characters_including_uppercase_and_lowercase_letters_and_numbers')"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('Register.rePswText')"
              prop="confirmPassword"
            >
              <el-input
                show-password
                v-model="form.confirmPassword"
                :placeholder="$t('please_input')"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('Register.verText')"
              prop="veriCodeType"
              class="vericode-form-item"
            >
              <el-radio
                v-model="veriCodeType"
                :label="2"
              >{{$t('Login.emailVer')}}</el-radio>
              <el-radio
                v-if="smsVerificationEnabled"
                v-model="veriCodeType"
                :label="1"
              >{{$t('Login.phoneVer')}}</el-radio>
            </el-form-item>
            <el-form-item
              prop="code"
            >
              <el-input
                v-model="form.code"
                :placeholder="$t('please_input')"
              >
                <div
                  class="code-suffix theme-color pointer"
                  slot="suffix">
                  <span
                    class="code-btn-text"
                    v-if="reSendMes"
                  >{{isCodeNumber}}s {{$t('Register.againVer')}}</span>
                  <span
                    v-else
                    class="code-btn-text active"
                    @click="getVerCode"
                  >{{$t('Send_verification_code')}}</span>

                </div>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
      </VuePerfectScrollbar>
    </div>
    <div
      class="footer-sidebar" slot="footer">
      <el-button
        @click="cancelHandle"
        type="text"
        class="calcel-btn"
      >{{$t('cancel')}}</el-button>
      <vs-button
        @click="submitHandle"
        color="primary"
        :disabled="submitLoading"
      >
        <span v-if="submitLoading"><i class="el-icon-loading"></i> </span>
        {{$t('Confirm')}}
      </vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { setBodyHidden,setBodyNormal } from "@/utils/common";
import { colorRgba } from "@/utils";
import { validatEmail, strongMt4DealPwd, isMobile,dealPassFisrtStrong, dealPassSecondStrong } from '@/utils/validate';
import { tCustMtaccount, updateCustPass, modifyMasterPwd, modifyInvPwd, SettingVer } from '@/api/userCenter.js';
import { mapGetters } from 'vuex'
import {mtAccList,getGroupByName,modifyLev} from '@/api/userCenter.js';
export default {
  name: "mt4PasswordSetting",
  components: {
    VuePerfectScrollbar,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    curLogin:{},
    isManInvertor: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    let _this = this;
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(_this.$t('User.plsInputPass')));
      } else {
        if (!strongMt4DealPwd(value)) {
          callback(new Error(_this.$t('Register.passwordDes')));
        }else {
          callback();
        }
      }
    };
    var validateRePass = (rule, value, callback) => {
      if(value == ''){
        callback(new Error(_this.$t('User.plsInputConfirmPass')));
      }else {
        if (value != _this.form.password) {
          callback(new Error(_this.$t('Register.notrepassword')));
        } else {
          callback();
        }
      }
    };
    return {
      title: _this.$t('User.passSet'),
      type: 1,
      typeList: [
        {label: _this.$t('User.passType2'),type: 1},
        {label: _this.$t('User.passType3'),type: 2},
      ],
      accountList: [],
      veriCodeType: 2,
      form: {
        login: '',
        password: '',
        confirmPassword: '',
        code: '',
      },
      rules: {
        login: [
          { required: true, message: _this.$t('please_choose'), trigger: 'blur' },
        ],
        password:[
          { validator: validatePass, trigger: 'blur'}
        ],
        confirmPassword:[
          { validator: validateRePass, trigger: 'blur'}
        ],
        code:[
          { required: true, message: _this.$t('User.plsInputPhoVer'), trigger: 'blur'}
        ],
      },
      reSendMes: false,
      isCodeNumber: 60,
      timer1: null,
      codeLoading: false,
      submitLoading: false,
      settings: {
        maxScrollbarLength : 60,
        wheelSpeed         : .60,
      },
    }
  },
  created(){
    this.getAccountList();
  },
  watch: {
    dialogShow(val){
      this.$refs.form && this.$refs.form.resetFields();
      this.$refs.form && this.$refs.form.clearValidate();
      if(val){
        setBodyHidden();
      }else {
        setBodyNormal();
      }
    },
    curLogin(newVal){
      if(newVal){
        this.form.login = newVal;
      }
    },
  },
  computed: {
    ...mapGetters(['userInfo','themeColor', 'smsVerificationEnabled']),
    verificationType(){
      return this.smsVerificationEnabled ? this.veriCodeType : 2;
    },
    computedList(){
      if(!this.isManInvertor){
        return this.typeList;
      }else {
        let fillterList = this.typeList.filter((item,index) => {
          return item.type == 2;
        });
        return fillterList;
      }
    }
  },
  methods: {
    modifyInvPwd,
    modifyMasterPwd,
    getAccountList(){
      let mtAccListData = {
        id : this.userInfo.id,
        isMock : '2',
        isTrial: false,
      }
      mtAccList(mtAccListData).then((res) => {
        this.accountList = res.data;
      })
    },
    typeHandle(item){
      this.type = item.type;
    },
    getBgcOpacity(item){
      if(item.type == this.type){
        return {
          backgroundColor: colorRgba(this.themeColor,0.1)
        }
      }
    },
    loginChangeHandle(){
      this.$refs.form && this.$refs.form.clearValidate(['login']);
    },
    close(){
      this.$emit('close')
    },
    closeHandle() {
      this.$refs.form && this.$refs.form.resetFields();
      this.$refs.form && this.$refs.form.clearValidate();
      this.close();
    },
    interfaceAjaxSuccess(){
      this.$emit('ajax-success');
    },
    getVerCode() {
      if (this.codeLoading || this.reSendMes) return;
      let parmas = {
        custId: this.userInfo.id,
        sendType: this.type == 1 ? 2 : 3,
        type: this.verificationType,
      };
      this.codeLoading = true;
      SettingVer(parmas).then((res) => {
        this.timerOut();
        this.reSendMes = true;
        this.$message({
          message: this.$t('User.verCodeSendSuccess'),
          type: 'success'
        });
      }).finally(() => {
        this.codeLoading = false;
      });
    },
    timerOut(){
      let _this = this;
      clearTimeout(this.timer1);
      this.timer1 = setTimeout(() => {
        clearTimeout(this.timer1)
        if(_this.isCodeNumber > 0){
          _this.isCodeNumber = --_this.isCodeNumber
          _this.timerOut();
        }else{
          clearTimeout(this.timer1)
          this.reSendMes = false;
          this.isCodeNumber = 60;
        }
      }, 1000);
    },
    submitHandle(){
      if (this.submitLoading) return;
      this.$refs.form.validate((valid) => {
        if(valid){
          const seluser = _.find(this.accountList, ['login', this.form.login]);
          let parmas = {
            verCode : this.form.code,
            custId:this.userInfo.id,
            serverId:seluser.serverId,
            login: this.form.login,
            type: this.verificationType,
          }
          if(this.type == 1){
            parmas.passwordPhone = this.form.confirmPassword;
          }else if(this.type == 2 || this.isManInvertor){
            parmas.passwordInvestor = this.form.confirmPassword;
          }
          let protype = ['modifyMasterPwd','modifyInvPwd'];
          this.submitLoading = true;
          this[protype[this.type - 1]](parmas).then((res) => {
            this.form.password = '';
            this.form.confirmPassword = '';
            this.form.code = '';
            this.colsecheckTransfer();
            this.interfaceAjaxSuccess();
          }).finally(() => {
            this.submitLoading = false;
          })
        }else {
          console.log('error');
        }
      })
    },
    colsecheckTransfer(){
      this.isCodeNumber = 60;
      clearTimeout(this.timer1);
      this.reSendMes = false;
      this.form.phoneCode = '';
    },
    cancelHandle(){
      this.close();
    }
  },
}
</script>
<style lang="scss">
.password-setting {
  .content {
    padding-top: 30px;

  }
  .vericode-form-item {
    margin-bottom: 5px;
  }
}
</style>
<style lang="scss">
.password-setting {
  .vs-sidebar--items {

  }
  .vs-sidebar {
    z-index: 1002;
    position: fixed;
    .sidebar-content {
    }
  }
  // sidebar弹框的遮罩层
  .vs-sidebar--background {
    z-index: 1001!important;
  }
  .scroll-area--customizer {
    height: calc(100% - 4rem);
  }

  .footer-sidebar {
    padding: 20px 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .calcel-btn {
      margin-right: 10px;
    }
  }
}
</style>
